module.exports = __webpack_public_path__ + "static/naked-lunch-6bada2967a853783b05924b80f967bf5.jpg";